import { render, staticRenderFns } from "./PrivacyEdit.vue?vue&type=template&id=2a0af108&"
import script from "./PrivacyEdit.vue?vue&type=script&lang=js&"
export * from "./PrivacyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports